<div class="main-login-container">
	<div class="wrapper">
		<div class="header1">
			<div class="logo"></div>
			<div class="login-nav-menu">
				<ul>
					<li>
						<span>
							<img [src]="'/assets/img/legacy/flag_' + lang + '.gif'" width="20" height="13" (click)="langsDisplayed = !langsDisplayed" alt="en">
						</span>
						&ngsp;
						<br>
						<span class="login-langues left1000 langs5"
							*ngIf="langsDisplayed"
							(mouseout)="outDivLangs()"
							(mouseover)="inDivLangs()"
							(focus)="inDivLangs()"
							(blur)="outDivLangs()"
							tabindex="0"
							@appearAnimation
							>
							<a (click)="setLanguage('de')"><img src="/assets/img/legacy/flag_de.gif" width="20" height="13" alt="de"></a>
							<a (click)="setLanguage('en')"><img src="/assets/img/legacy/flag_en.gif" width="20" height="13" alt="en"></a>
							<a (click)="setLanguage('es')"><img src="/assets/img/legacy/flag_es.gif" width="20" height="13" alt="es"></a>
							<a (click)="setLanguage('fr')"><img src="/assets/img/legacy/flag_fr.gif" width="20" height="13" alt="fr"></a>
							<a (click)="setLanguage('it')"><img src="/assets/img/legacy/flag_it.gif" width="20" height="13" alt="it"></a>
							<a (click)="setLanguage('pl')"><img src="/assets/img/legacy/flag_pl.gif" width="20" height="13" alt="pl"></a>
						</span>
					</li>

					<li>
						<div class="login-contact-us" translate>
							<a [href]="emailContactUsToSupport" target="_top"><span translate>login-legacy.contact-us</span></a>
						</div>
					</li>

				</ul>
			</div>
		</div>

		<div class="header2">
			<div class="table-fixed bandeau_login">
				<div class="table-row">
					<div class="table-cell logo_steeluser"></div>
					<div class="table-cell pl58 copo-legacy-relative">
						<form [formGroup]="loginFormGroup" (ngSubmit)="onSubmit()" novalidate autocomplete="off">
							<div class="table-fixed login-table">
								<div class="table-row">
									<div class="table-cell input-login">
										<input type="text" [placeholder]="'login-legacy.username' | translate" name="username" autocomplete="username" formControlName="username">
									</div>
									<div class="table-cell input-password">
										<input type="password" [placeholder]="'login-legacy.password' | translate" name="password" autocomplete="current-password" formControlName="password">
										<button color="accent" class="access-button" type="submit" [disabled]="submitting">
											<span class="copo-legacy-nowrap" *ngIf="!submitting; else submittingMessage" translate>login-legacy.connect</span>
											<ng-template #submittingMessage><span translate>login.loading</span></ng-template>
										</button>
									</div>
								</div>
								<div class="table-row login-table-row">
									<div class="table-cell fsdf parent-remember-me">
										<span translate>login-legacy.remember-me</span><input type="checkbox" name="remembermecheckbox" class="checkbox-rememberme" formControlName="rememberMe">
									</div>
									<div class="table-cell parent-lost-password">
										<a class="lost-password pointer" (click)="lostPasswordDisplayed = !lostPasswordDisplayed"
										(mouseout)="onLostPasswordOut()"
										(mouseover)="onLostPasswordOver()"
										(focus)="onLostPasswordOver()"
										(blur)="onLostPasswordOut()"
										>
											<span translate>login-legacy.lost-password</span>
											<img [src]="'/assets/img/legacy/arrow_down' + lostPasswordOverImg + '.png'" class="arrow arrow-lost-pwd" alt="v">
										</a>
									</div>
								</div>
							</div>
						</form>
						<form [formGroup]="forgotPasswordFormGroup" (ngSubmit)="onForgotPasswordSubmit()" novalidate autocomplete="off">
							<div class="pwd_lost pwd_lost_old"
								*ngIf="lostPasswordDisplayed"
								@appearAnimation>
									<div class="pwd_lost_corner">
										<div class="pwd_lost_corner_top"></div>
										<div class="pwd_lost_corner_bottom"></div>
									</div>
									<div class="pwd_lost_content pwd_lost_content_old">
										<input type="text" [placeholder]="'login-legacy.email-address' | translate" formControlName="userEmail" autocomplete="email">
										<br><br>
										<button color="accent" class="access-button" type="submit" [disabled]="(userEmail && userEmail.errors && userEmail.errors['pattern']) || lostPasswordSubmitting">
											<span class="copo-legacy-nowrap" *ngIf="!lostPasswordSubmitting; else lostPasswordSubmittingMessage" translate>login-legacy.send</span>
											<ng-template #lostPasswordSubmittingMessage><span translate>login.loading</span></ng-template>
										</button>
									</div>
								</div>
						</form>
					</div>

					<div class="table-cell parent-not-referenced">
						<a [href]="emailBecomeMemberToSupport" target="_top" class="buy pointer"
						(mouseout)="onNotReferencedOut()"
						(mouseover)="onNotReferencedOver()"
						(focus)="onNotReferencedOver()"
						(blur)="onNotReferencedOut()">
							<span translate>login-legacy.not-referenced</span>&ngsp;
							<img [src]="'/assets/img/legacy/arrow_right' + notReferencedOverImg + '.png'" alt=">">
						</a>
					</div>
					<div class="table-cell border-login">

					</div>
				</div>
			</div>
		</div>
	</div>
		<div id="news-and-middle" class="news-and-middle">
			<div class="news">
				<div class="news_corner"></div>
				<div class="news_title">
					<span class="light_gray" translate>login-legacy.welcome</span><br>
				</div>
			</div>
			<div class="middle">
				<div [ngSwitch]="chapter">
					<ng-container *ngSwitchCase="'aboutSteelUser'">
						<div class="table-fixed">
							<div class="table-row">
								<div class="table-cell parent-col-chapter">
									<div class="col_left" translate>
										<h1 translate>login-legacy.new-steel-market</h1><br>
										<span translate>login-legacy.new-steel-market-content</span>
									</div>
								</div>
								<div class="table-cell parent-col-chapter">
									<div class="col_right">
										<h1 translate>login-legacy.customer-benefits</h1><br>
										<span translate>login-legacy.by-registering-as</span>
										<ul class="login-ul">
											<li translate>login-legacy.advantages-arising</li>
											<li translate>login-legacy.online-ofu</li>
											<li translate>login-legacy.salesdocs-access</li>
											<li translate>login-legacy.much-more</li>
										</ul>
									</div>
								</div>
							</div>
							<div class="table-row">
								<div class="table-cell parent-col-chapter">
									<div class="col_left">
										<h1 translate>login-legacy.our-it-providers</h1><br>
										<span translate>login-legacy.am-itswe</span>
									</div>
								</div>
								<div class="table-cell parent-col-chapter"></div>
							</div>
						</div>
					</ng-container>
					<ng-container *ngSwitchCase="'customization'">
						<div class="table-fixed">
							<div class="table-row">
								<div class="table-cell parent-col-chapter">
									<div class="col_left">
										<h1 translate>login-legacy.customization</h1><br>
										<span translate>login-legacy.after-login</span>
										<ul>
											<li translate>login-legacy.offer-made-by</li>
										</ul>
									</div>
								</div>
								<div class="table-cell parent-col-chapter">
									<div class="col_right">
										<h1><span class="not-visible">Title</span></h1><br>
										<ul>
											<li translate>login-legacy.access-to-sales</li>
											<li translate>login-legacy.possibility-of-making</li>
											<li translate>login-legacy.access-to-secure</li>
											<li translate>login-legacy.sales-corresp</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
					<ng-container *ngSwitchCase="'salesServices'">
						<div class="table-fixed">
							<div class="table-row">
								<div class="table-cell parent-col-chapter">
									<div class="col_left">
										<h1 translate>login-legacy.follow-up-order</h1><br>
										<span translate>login-legacy.enables-you-to-check</span>
									</div>
								</div>
								<div class="table-cell parent-col-chapter">
									<div class="col_right">
										<h1 translate>login-legacy.sales-documents</h1><br>
										<span translate>login-legacy.display-printing</span>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
					<ng-container *ngSwitchCase="'salesServices'">
						<div class="table-fixed">
							<div class="table-row">
								<div class="table-cell parent-col-chapter">
									<div class="col_left">
										<h1 translate>login-legacy.follow-upon-flows</h1><br>
										<span translate>login-legacy.follow-up-specific</span>
										<ul>
											<li translate>login-legacy.system-designed</li>
											<li translate>login-legacy.this-shared-info</li>
											<li translate>login-legacy.technologies-used</li>
											<li translate>login-legacy.functionality-access</li>
										</ul>
									</div>
								</div>
								<div class="table-cell parent-col-chapter">
									<div class="col_right">
										<h1 translate>login-legacy.exchange-center</h1><br>
										<span translate>login-legacy.enables-you-to-correspond</span>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
					<ng-container *ngSwitchCase="'AMFCE'">
						<div class="table-fixed">
							<div class="table-row">
								<div class="table-cell parent-col-chapter">
									<div class="col_left">
										<h1 translate>login-legacy.am-fce</h1><br>
										<span translate>login-legacy.am-fce-content</span>
										<br><br>
										<a (click)="openAmfceTermsConditionsDialog()" translate>login-legacy.terms-conditions</a>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
					<ng-container *ngSwitchCase="'AMDS'">
						<div class="table-fixed">
							<div class="table-row">
								<div class="table-cell parent-col-chapter">
									<div class="col_left">
										<h1 translate>login-legacy.amds</h1><br>
										ArcelorMittal Distribution Solutions
										<br><br>
										<a (click)="openAmdsTermsConditionsDialog()" translate>login-legacy.terms-conditions</a>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
			<div class="service">
				<h1><span class="login-service-h1" translate>login-legacy.our-services</span></h1><br>
				<ul class="list">
					<li>
						<span [ngClass]="chapter === 'aboutSteelUser' ? 'servicesLinkSelected pl15' : 'servicesLink pl15'">
							<a (click)="chapter = 'aboutSteelUser'" translate>login-legacy.about-steeluser</a>
						</span>
					</li>
					<li>
						<span [ngClass]="supplierDisplayed ? 'servicesLinkDown pl15' : 'servicesLink pl15'">
							<a (click)="supplierDisplayed = !supplierDisplayed" translate>login-legacy.your-suppliers</a>
						</span>
						<div *ngIf="supplierDisplayed">
							<span [ngClass]="chapter === 'AMFCE' ? 'servicesLinkListSelected pl25' : 'servicesLinkList pl25'">
								&ndash;&ngsp;<a (click)="chapter = 'AMFCE'" translate>login-legacy.am-fce</a>
							</span><br>
							<span [ngClass]="chapter === 'AMDS' ? 'servicesLinkListSelected pl25' : 'servicesLinkList pl25'">
								&ndash;&ngsp;<a (click)="chapter = 'AMDS'" translate>login-legacy.amds</a>
							</span>
						</div>
					</li>
					<li>
						<span [ngClass]="chapter === 'customization' ? 'servicesLinkSelected pl15' : 'servicesLink pl15'">
							<a (click)="chapter = 'customization'" translate>login-legacy.customization</a>
						</span>
					</li>
					<li>
						<span [ngClass]="chapter === 'salesServices' ? 'servicesLinkSelected pl15' : 'servicesLink pl15'">
							<a (click)="chapter = 'salesServices'" translate>login-legacy.sales-services</a>
						</span>
					</li>
					<li>
						<span [ngClass]="termsSupplierDisplayed ? 'servicesLinkDown pl15' : 'servicesLink pl15'">
							<a (click)="termsSupplierDisplayed = !termsSupplierDisplayed" translate>login-legacy.terms-conditions</a>
						</span>
						<div *ngIf="termsSupplierDisplayed">
							<span class="pl25">
								<a (click)="openAmfceTermsConditionsDialog()">&ndash;&ngsp;<span translate>login-legacy.am-fce</span></a>
							</span>
							<br>
							<span class="pl25">
								<a (click)="openAmdsTermsConditionsDialog()">&ndash;&ngsp;<span translate>login-legacy.amds</span></a>
							</span>
						</div>
					</li>
					<li>
						<span [ngClass]="usefulLinksDisplayed ? 'servicesLinkDown pl15' : 'servicesLink pl15'">
							<a (click)="usefulLinksDisplayed = !usefulLinksDisplayed" translate>login-legacy.useful-links</a>
						</span>
						<div *ngIf="usefulLinksDisplayed">
							<span class="pl25">
								<a href="http://corporate.arcelormittal.com/who-we-are/interactive-map" target="_blank">&ndash;&ngsp;<span translate>login-legacy.amou</span></a>
							</span>
							<br>
							<span class="pl25">
								<a href="http://www.otua.org/" target="_blank">&ndash;&ngsp;<span translate>login-legacy.otua</span></a>
							</span>
						</div>
					</li>
				</ul>

				<a [href]="'https://www.steeluser.com/download/managedownloadfile/downloadfile.stujson?fileName=CGU&amp;type=pdf&amp;nature=legal_document&amp;lang=' + lang + '&amp;_dc=1563276272040'"
					target="_blank" class="copo-legacy-download-link" translate>login-legacy.terms-of-use</a>&nbsp;(PDF)
			</div>

		</div>
		<div id="login-footer" class="login-footer">
			© ArcelorMittal {{ year }}
			&ndash;&ngsp;<a (click)="openPrivacyPolicyDialog()" translate>login-legacy.privacy-policy</a>
			&ndash;&ngsp;<a (click)="openPrivacySettingsDialog()" translate>login-legacy.privacy-settings</a>
			&ndash;&ngsp;<a (click)="openFaqDialog()" translate>login-legacy.faq</a>
			<div class="middle_corner"></div>
		</div>
</div>